import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';

@Component({
  selector: 'beplic-room-modal-meta',
  templateUrl: './room-modal-meta.component.html',
  styleUrls: ['./room-modal-meta.component.scss'],
})
export class RoomModalMetaComponent implements OnInit {
  constructor(
    public matDialogRef: MatDialogRef<RoomModalMetaComponent>,
    public _matDialog: MatDialog
  ) {}

  ngOnInit() {}
}
